import React from 'react'
import { CustomLink } from './styles'
import { getPresignedUrlForPdf } from '../../../../../static-files/static-pdf-service'

const downloadOrderPdf = async (orderNumber) => {
  const url = await getPresignedUrlForPdf('application-static-resources', 'us-east-1', `NetSuiteOrderPdfs/${orderNumber}`)
  window.open(url)
}

export default ({ order, shipment, openOrderModal, origin, orderData }) => {
  return (
    <React.Fragment>
      <div>
        Order #:
        <CustomLink
          onClick={() => {
            if (origin === 'Salesforce') {
              openOrderModal(orderData)
            } else {
              downloadOrderPdf(order.orderNumber)
            }
          }}
        >
          {order.orderNumber}
        </CustomLink>
      </div>
      <div>Reference: {shipment.reference}</div>
    </React.Fragment>
  )
}
